"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefContext = exports.RefsContext = void 0;

var react_1 = require("react");

exports.RefsContext = (0, react_1.createContext)({});

function useRefContext(key) {
  var refs = (0, react_1.useContext)(exports.RefsContext);
  return refs[key];
}

exports.useRefContext = useRefContext;